import React from 'react';
import { Alert } from 'react-bootstrap';
const ReviewStatusMessage = _ref => {
  let {
    status,
    isReviewer,
    isConsultant
  } = _ref;
  if (status === 'pending' && !isReviewer) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pt-3 border-top"
    }, /*#__PURE__*/React.createElement(Alert, {
      variant: "info",
      className: "mb-0"
    }, /*#__PURE__*/React.createElement("small", null, "Awaiting reviewer action")));
  }
  if (status === 'clarification_required' && !isConsultant) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pt-3 border-top"
    }, /*#__PURE__*/React.createElement(Alert, {
      variant: "danger",
      className: "mb-0"
    }, /*#__PURE__*/React.createElement("small", null, "Awaiting consultant response")));
  }
  return null;
};
export default ReviewStatusMessage;